<template>
    <process-directory :type="2" title="Falências" route-base="/falencia" />
</template>
<script>
import ProcessDirectory from '@/components/ProcessDirectory.vue';
export default { name: 'BankRuptcyPage', components: { ProcessDirectory } };
</script>
